import React from "react";
import { Route, Routes } from "react-router-dom";
import AssistantPage from "./AssistantPage";

export const AssistantRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<AssistantPage />} />
    </Routes>
  );
};
